import React, { useState,useEffect } from 'react'
import {
    Button,
    FormControl,
    FormLabel,
    Icon,
    IconButton,
    Input,
    Text,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack,
    Tooltip,
    Select,
    Radio,
    RadioGroup,
    InputGroup,
    InputRightElement,
    Switch
} from '@chakra-ui/react'
import { VscEdit } from 'react-icons/vsc'
import { updateUsuario, getUsuarios } from '../../features/usuarioSlice';
import { useDispatch ,useSelector} from 'react-redux';
import { getPersonaByCedula, reset } from '../../features/personaSlice';
import { getSelectRols} from '../../features/rolSlice';
import { Search2Icon } from '@chakra-ui/icons';
import { ModalBuscarPersona } from './ModalBuscarPersona'; 

export const ModalEditarUsuario = ({ row, page, perPage }) => {

        const dispatch = useDispatch();
        const { personaPorCedula, isErrorCedula} = useSelector((state) => state.persona);
        const [isBuscarModalOpen, setIsBuscarModalOpen] = useState(false);
   
        const isValidEmail = (email) => {
           return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
       };
        const [emailError, setEmailError] = useState('');
   
        const [isModalOpen, setIsModalOpen] = useState(false);
   
        const initialValues = { 
           username: '',
           email: '',
           personaId: '',
           rolId : '',
           password: '',
           confirmPassword: '',
           nombre: '', 
           cedula: '',
           estado: true, 
           cambiarPassword: true // Asumimos que el usuario siempre quiere cambiar la contraseña al crear un nuevo usuario
       };
       const [indice, setIndice] = useState(initialValues);

       const handleModalOpen = (data) => {
        setIsModalOpen(true);

        setIndice({
            id: data.id, // ✅ <-- AÑADE EL ID AQUÍ
            nombre: data.persona.nombre + ' ' + data.persona.apellido || '',
            personaId: data.persona.id || '',
            cedula: data.persona.cedula || '',
            username: data.username || '',
            email : data.email || '',
            estado: data.estado ?? true,
            rolId: data.rol.id || '',
            cambiarPassword: data.cambiarPassword ?? true, // Asumimos que el usuario siempre quiere cambiar la contraseña al editar un usuario
            password: '', // Limpiamos el campo de contraseña al abrir el modal
            confirmPassword: '', // Limpiamos el campo de confirmación de contraseña al abrir el modal
        });
        //setIndice({ ...data }); // ✅ Clona el objeto para evitar referencias circulares
       };

       const [passwordError, setPasswordError] = useState('');
       const [confirmPasswordError, setConfirmPasswordError] = useState('');
   
   
        const { roles } = useSelector((state) => state.rol);
       
           useEffect(() => {
               if (isModalOpen) {
                   dispatch(getSelectRols());
               }
           }, [isModalOpen, dispatch]);
       
   
       const validatePassword = (password) => {
           // Expresión regular: al menos 6 caracteres y al menos un número
           const regex = /^(?=.*\d).{6,}$/;
           return regex.test(password);
       };
   
       const handlePasswordChange = (e) => {
           const value = e.target.value;
           setIndice({ ...indice, password: value });
   
           if (!validatePassword(value)) {
               setPasswordError('La contraseña debe tener al menos 6 caracteres y contener al menos un número.');
           } else {
               setPasswordError('');
           }
       };
   
       const handleConfirmPasswordChange = (e) => {
           const value = e.target.value;
           setIndice({ ...indice, confirmPassword: value });
   
           if (value !== indice.password) {
               setConfirmPasswordError('Las contraseñas no coinciden.');
           } else {
               setConfirmPasswordError('');
           }
       };

       const handleModalClose = () => {
          //dispatch(reset());
           setIsModalOpen(false);
           setIndice(initialValues);
       };
   
       // ⬅️ Este hook debe estar fuera de la función handleBuscarPersona
       useEffect(() => {
           if (personaPorCedula) {
               setIndice((prev) => ({
                   ...prev,
                   nombre: personaPorCedula.nombre + ' ' + personaPorCedula.apellido,
                   personaId: personaPorCedula.id,
                   email : personaPorCedula.email ? personaPorCedula.email : '', // Asignar email si existe
               }));
           } 
       }, [personaPorCedula]);
   
       // Limpia los campos si hay error al buscar por cédula
       useEffect(() => {
           if (isErrorCedula) {
               setIndice((prev) => ({
                   ...prev,
                   nombre: '',
                  // cedula: '',
                   personaId: '',
               }));
               dispatch(reset()); // limpia estado de error del slice si es necesario
           }
       }, [isErrorCedula]);
   
       const handleBuscarPersona = () => {
           if (!indice.cedula.trim()) {
                setIsBuscarModalOpen(true); // Abrimos el modal
                return;   
           }
       
           // Ejecuta el dispatch para buscar persona
           dispatch(getPersonaByCedula(indice.cedula));
       }
   
       // Esta función se llamará desde el modal al hacer clic en una persona
       const handleSeleccionarPersona = (persona) => {
           setIndice({
               ...indice,
               cedula: persona.cedula,
               nombre: persona.nombre + ' ' + persona.apellido,
               personaId: persona.id,
               email: persona.email ? persona.email : '', // Asignar email si existe
   
           });
   
           setIsBuscarModalOpen(false); // Cerramos el modal
       };

       const handleUpdate = () => {
        // Validación de email
        if (!isValidEmail(indice.email)) {
            setEmailError('Por favor, ingrese un email válido.');
            return;
        }  

        if (indice.password && indice.cambiarPassword) {
            if (indice.password !== indice.confirmPassword) {
                setConfirmPasswordError('Las contraseñas no coinciden.');
                return;
            }

            if (!validatePassword(indice.password)) {
                setPasswordError('La contraseña debe tener al menos 6 caracteres y un número.');
                return;
            }
        }
            
            
    
        // Construimos un payload limpio
        const usuarioActualizado = {
            id: indice.id,
            username: indice.username,
            email: indice.email,
            personaId: indice.personaId,
            rolId: indice.rolId,
            estado: indice.estado,
            cambiarPassword: indice.cambiarPassword,
            ...( indice.password && { password: indice.password })
        };
    
        dispatch(updateUsuario(usuarioActualizado)).then(() => {
            dispatch(getUsuarios({ page, perPage }));
            setIsModalOpen(false);
        });
    };
    

    return (
        <>
            <Tooltip hasArrow label='Editar' placement='auto'>
                <IconButton
                    colorScheme="blackAlpha"
                    _dark={{ color: "white", _hover: { bg: "whiteAlpha.200" } }}
                    aria-label="Editar"
                    icon={<Icon as={VscEdit}
                        fontSize="2xl" />}
                    variant="ghost"
                    onClick={() => handleModalOpen(row)}
                    ml={2}
                />
            </Tooltip>
            <Modal isOpen={isModalOpen} onClose={handleModalClose} size="5xl" isCentered>
                <ModalOverlay
                    bg="rgba(11,15,25, 0.8)"
                    backdropFilter='auto'
                    backdropBlur='2px'
                />
                <ModalContent _dark={{ bg: "primary.1000" }} borderRadius="2xl">
                    <ModalHeader textAlign="center">ACTUALIZAR USUARIO</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                         <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <Text fontWeight="semibold">ESTADO</Text>
                            <Switch onChange={(e) => setIndice({ ...indice, estado: e.target.checked })} value={indice ? indice.estado : null} colorScheme="purple" isChecked={indice.estado === true ? true : false} size='lg' />
                        </Stack>
                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl isRequired flex="1">
                                <FormLabel fontWeight="semibold">CEDULA</FormLabel>
                                <InputGroup>
                                    <Input
                                        type="text"
                                        placeholder="Ingrese nro de cedula"
                                        value={indice.cedula}
                                        //onChange={(e) => setIndice({ ...indice, cedula: e.target.value })}
                                    />
                                    <InputRightElement width="2.5rem">
                                        <Tooltip hasArrow label="Buscar persona" placement="auto">
                                            <IconButton
                                                aria-label="Buscar"
                                                rounded="full"
                                                size="xs"
                                                icon={<Icon as={Search2Icon} fontSize="md" />}
                                                colorScheme="green"
                                                variant="solid"
                                                onClick={handleBuscarPersona} // Llama a la función para buscar el cliente
                                            />
                                        </Tooltip>
                                    </InputRightElement>
                                </InputGroup>
                            </FormControl>

                            <FormControl isRequired flex="2">
                                <FormLabel fontWeight="semibold">NOMBRE</FormLabel>
                                <Input
                                    placeholder="Nombre de la persona"
                                    type="text"
                                    value={indice.nombre}
                                    onChange={(e) => setIndice({ ...indice, nombre: e.target.value })}
                                    isReadOnly // Hace que el campo sea de solo lectura
                                />
                            </FormControl>
                        </Stack>

                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl isRequired>
                                <FormLabel fontWeight="semibold">USUARIO</FormLabel>
                                <Input
                                    placeholder="Nombre de usuario"
                                    type="text"
                                    value= {indice.username}
                                    onChange={(e) => setIndice({ ...indice, username: e.target.value })}
                                    
                                />
                            </FormControl>

                            <FormControl isInvalid={!!emailError} isRequired>
                                <FormLabel fontWeight="semibold">EMAIL</FormLabel>
                                <Input
                                    placeholder="Ingrese el email"
                                    type="email"
                                    value={indice.email}
                                    onChange={(e) => setIndice({ ...indice, email: e.target.value })}
                                    onBlur={(e) => {
                                        const value = e.target.value;
                                        if (!isValidEmail(value)) {
                                            setEmailError('Por favor, ingrese un email válido.');
                                        } else {
                                            setEmailError('');
                                        }
                                    }}  
                                />
                                {emailError && (
                                    <Text color="red.500" fontSize="sm" mt={1}>
                                        {emailError}
                                    </Text>
                                )}
                            </FormControl>
                        </Stack>
                        
                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                                <FormControl isRequired>
                                    <FormLabel fontWeight="semibold">ROL</FormLabel>
                                    <Select
                                        placeholder="Seleccione un rol"
                                        onChange={(e) => setIndice({ ...indice, rolId: e.target.value })}
                                        value={indice.rolId}
                                    >
                                    {roles.map((rol) => (
                                        <option key={rol.id} value={rol.id}>
                                            {rol.key}
                                        </option>
                                    ))}
                                    </Select>
                                </FormControl>

                                <FormControl isRequired>
                                    <FormLabel fontWeight="semibold">CAMBIAR CONTRASEÑA</FormLabel>
                                    <RadioGroup
                                        value={indice.cambiarPassword ? 'true' : 'false'}
                                        onChange={(value) => setIndice({ ...indice, cambiarPassword: value === 'true' })}
                                    >
                                        <Stack direction="row">
                                            <Radio value="true" colorScheme="green">
                                                SI
                                            </Radio>
                                            <Radio value="false" colorScheme="red">
                                                NO
                                            </Radio>
                                        </Stack>
                                    </RadioGroup>
                                </FormControl>
                        </Stack>
                        <Stack spacing={4} direction={{ base: "column", lg: "row"}} justifyContent="space-between" p={4}>
                            <FormControl isRequired>
                                <FormLabel>CONTRASEÑA</FormLabel>
                                <Input
                                    type="password"
                                    placeholder="Ingrese la contraseña"
                                    value={indice.password}
                                    onChange={handlePasswordChange}
                                />
                                {passwordError && (
                                    <Text color="red.500" fontSize="sm" mt={1}>
                                        {passwordError}
                                    </Text>
                                )}
                            </FormControl>

                            <FormControl isRequired>
                                <FormLabel>CONFIRMAR CONTRASEÑA</FormLabel>
                                <Input
                                    type="password"
                                    placeholder="Confirme la contraseña"
                                    value={indice.confirmPassword}
                                    onChange={handleConfirmPasswordChange}
                                />
                                {confirmPasswordError && (
                                    <Text color="red.500" fontSize="sm" mt={1}>
                                        {confirmPasswordError}
                                    </Text>
                                )}
                            </FormControl>
                        </Stack>
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="red" _dark={{ bg: "red.500", color: "white", _hover: { bg: "red.600" } }} size="lg" mr={3} onClick={handleModalClose} borderRadius="xl">
                            CANCELAR
                        </Button>
                        <Button
                            colorScheme="green"
                            _dark={{ bg: "green.500", color: "white", _hover: { bg: "green.600" } }}
                            size="lg"
                            mr={3}
                            onClick={handleUpdate}
                            borderRadius="xl"
                            isDisabled={ !indice.username || !indice.email || !indice.rolId || !indice.personaId }
                        >
                            ACTUALIZAR
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* 👉 Aquí se integra el ModalBuscarPersona */}
            <ModalBuscarPersona
                isOpen={isBuscarModalOpen}
                onClose={() => setIsBuscarModalOpen(false)}
                onSelectPersona={handleSeleccionarPersona}
            />
        </>
    )
}
